<template>
  <form @submit.prevent="submitSupplierForm">
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Full Name') }}</label><span class="text-danger">*</span>
          <input
            type="text"
            class="form-control"
            v-model="supplierForm.name"
            :placeholder="$t('Full Name')"
            required
            name="name"
          />
          <small class="text-danger" v-if="supplierErrors.name">{{ supplierErrors.name[0] }}</small>
        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Email') }}</label>
          <input
            type="email"
            class="form-control"
            v-model="supplierForm.email"
            :placeholder="$t('Your Email')"
            name="email"
          />
          <small class="text-danger" v-if="supplierErrors.email">{{ supplierErrors.email[0] }}</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Phone') }}</label>
          <span class="text-danger">*</span>
          <input
            ref="phoneInput"
            type="tel"
            class="form-control"
            name="phone"
            :placeholder="$t('Phone')"
          />
          <small
            class="text-danger"
            v-if="supplierErrors.phone"
          >
            {{ supplierErrors.phone[0] }}
          </small>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 mb-3">
        <div class="form-group">
          <label class="mb-1">{{ $t('Password') }}</label><span class="text-danger">*</span>
          <input
            type="password"
            class="form-control"
            v-model="supplierForm.password"
            placeholder="*******"
            name="password"
          />
          <small class="text-danger" v-if="supplierErrors.password">{{ supplierErrors.password[0] }}</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Category') }}</label><span class="text-danger">*</span>
          <select
            class="form-control"
            v-model="supplierForm.category_id"
            name="category_id"
          >
            <option disabled value="">{{ $t('Select Category') }}</option>
            <option
              v-for="category in props.categories"
              :key="category.value"
              :value="category.value"
            >
              {{ category.label }}
            </option>
          </select>
          <small class="text-danger" v-if="supplierErrors.category_id">{{ supplierErrors.category_id[0] }}</small>
        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('City') }}</label><span class="text-danger">*</span>
          <select
            class="form-control"
            v-model="supplierForm.state_id"
            name="state_id"
          >
            <option disabled value="">{{ $t('Select City') }}</option>
            <option
              v-for="state in props.states"
              :key="state.value"
              :value="state.value"
            >
              {{ state.label }}
            </option>
          </select>
          <small class="text-danger" v-if="supplierErrors.state_id">{{ supplierErrors.state_id[0] }}</small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
            <label class="mb-1">{{ $t('Area') }}</label>
            <span class="text-danger">*</span>

            <select
                class="form-control"
                v-model="supplierForm.city_id"
            >
                <option
                    disabled
                    value=""
                >
                    {{ $t('Select Area') }}
                </option>

                <option
                    v-for="city in cities"
                    :key="city.id"
                    :value="city.id"
                >
                    {{ city.name }}
                </option>
            </select>
            <small
                v-if="supplierErrors.city_id"
                class="text-danger"
            >
                {{ supplierErrors.city_id[0] }}
            </small>
        </div>
    </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Company Email') }}</label>
          <input
            type="email"
            class="form-control"
            v-model="supplierForm.company_email"
            :placeholder="$t('Company Email')"
            name="company_email"
          />
          <small class="text-danger" v-if="supplierErrors.company_email">{{ supplierErrors.company_email[0] }}</small>
        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Company landline Phone') }}</label>
          <input
            type="text"
            class="form-control"
            v-model="supplierForm.company_landline_phone"
            :placeholder="$t('Company landline Phone')"
            name="company_landline_phone"
          />
          <small class="text-danger" v-if="supplierErrors.company_landline_phone">{{ supplierErrors.company_landline_phone[0] }}</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Factory Phone') }}</label>
          <input
            ref="factoryPhoneInput"
            type="tel"
            class="form-control"
            name="factory_phone"
            :placeholder="$t('Factory Phone')"
          />
          <small
            class="text-danger"
            v-if="supplierErrors.factory_phone"
          >
            {{ supplierErrors.factory_phone[0] }}
          </small>
        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Sales Phone') }}</label>
          <input
            ref="salesPhoneInput"
            type="tel"
            class="form-control"
            name="sales_phone"
            :placeholder="$t('Sales Phone')"
          />
          <small
            class="text-danger"
            v-if="supplierErrors.sales_phone"
          >
            {{ supplierErrors.sales_phone[0] }}
          </small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Website Url') }}</label>
          <input
            type="url"
            class="form-control"
            v-model="supplierForm.website_url"
            :placeholder="$t('Website Url')"
            name="website_url"
          />
          <small class="text-danger" v-if="supplierErrors.website_url">{{ supplierErrors.website_url[0] }}</small>
        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Branch Name') }}<span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="supplierForm.branch_name"
            :placeholder="$t('Branch Name')"
            required
            name="branch_name"
          />
          <small class="text-danger" v-if="supplierErrors.branch_name">{{ supplierErrors.branch_name[0] }}</small>
        </div>
      </div>
    </div>


    <div class="form-group">
      <button
        type="submit"
        class="btn btn-primary full-width fw-medium"
        :disabled="isSubmitting"
      >
        <span v-if="isSubmitting">
          {{ $t('Creating...') }}
        </span>

        <span v-else>
          {{ $t('Create An Account') }}
          <i
            class="fa-solid px-2"
            :class="$i18n.locale === 'ar'
              ? 'fa-arrow-left-long'
              : 'fa-arrow-right-long'"
          ></i>
        </span>
      </button>
    </div>
  </form>
</template>

<script setup>
import { ref, defineProps ,onMounted, onBeforeUnmount, watch } from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toastification'
import { useRouter } from 'vue-router';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
const toast = useToast()
const { t , locale} = useI18n()
const router = useRouter();


const phoneInput = ref(null)
const factoryPhoneInput = ref(null)
const salesPhoneInput = ref(null)

const phoneIti = ref(null)
const factoryPhoneIti = ref(null)
const salesPhoneIti = ref(null)
const isSubmitting = ref(false)

const props = defineProps({
  states: Array,
  categories: Array,
})

const supplierErrors = ref({})
const cities = ref([])
const supplierForm = ref({
  name: '',
  email: '',
  phone: '',
  password: '',
  state_id: '',
  city_id:'',
  category_id: '',
  company_email:'',
  company_landline_phone:'',
  factory_phone:'',
  sales_phone:'',
  website_url:'',
  branch_name:''

})

const validatePhone = (itiInstance, inputRef, field, required = false) => {
  if (!itiInstance || !inputRef) {
    return true
  }

  const rawValue = inputRef.value?.trim()

  if (!rawValue && !required) {
    supplierForm.value[field] = ''
    return true
  }

  if (!rawValue && required) {
    supplierErrors.value[field] = [
      t('validation.required', {
        field: t(`fields.${field}`)
      })
    ]

    return false
  }

  if (!itiInstance.isValidNumber()) {
    supplierErrors.value[field] = [
      t('validation.invalid_phone')
    ]

    return false
  }

  supplierForm.value[field] = itiInstance.getNumber()

  return true
}
const fetchCities = async (stateId) => {
  if (!stateId) {
    cities.value = []
    supplierForm.value.city_id = ''
    return
  }

  try {
    const response = await axios.get(
      `/get-cities/${stateId}`,
      {
        headers: {
          locale: locale.value
        }
      }
    )

    cities.value = response.data.cities || []

  } catch (error) {
    console.error('Error fetching cities:', error)

    cities.value = []
  }
}
watch(
  () => supplierForm.value.state_id,
  (newStateId) => {
    supplierForm.value.city_id = ''
    fetchCities(newStateId)
  }
)
const submitSupplierForm = async () => {
  if (isSubmitting.value) return
  supplierErrors.value = {}
  let formValid = true

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  const requiredFields = ['name', 'password', 'category_id', 'state_id']

  requiredFields.forEach((field) => {
    if (!supplierForm.value[field]) {
      supplierErrors.value[field] = [t('validation.required', { field: t(`fields.${field}`) })]
      formValid = false
    }
  })

  const mainPhoneValid = validatePhone(
    phoneIti.value,
    phoneInput.value,
    'phone',
    true
  )

  if (!mainPhoneValid) {
    formValid = false
  }

  const factoryPhoneValid = validatePhone(
    factoryPhoneIti.value,
    factoryPhoneInput.value,
    'factory_phone',
    false
  )

  if (!factoryPhoneValid) {
    formValid = false
  }

  const salesPhoneValid = validatePhone(
    salesPhoneIti.value,
    salesPhoneInput.value,
    'sales_phone',
    false
  )

  if (!salesPhoneValid) {
    formValid = false
  }


  if (supplierForm.value.email && !emailRegex.test(supplierForm.value.email)) {
    supplierErrors.value.email = [t('validation.invalid_email')]
    formValid = false
  }

  if (supplierForm.value.company_email && !emailRegex.test(supplierForm.value.company_email))
   {
    supplierErrors.value.company_email = [
      t('validation.invalid_email')
    ]

    formValid = false
  }
  if (!formValid) return
  isSubmitting.value = true
  try {
    const formData = new FormData()

    Object.entries(supplierForm.value).forEach(([key, value]) => {
      formData.append(key, value ?? '')
    })

    const res = await axios.post('/users/service-provider/register', formData)

    const userId = res.data.service_provider_details.id
    const token = res.data.token
    const userRole = res.data.service_provider_details.user_role;
    localStorage.setItem('auth_token', token) 
    localStorage.setItem('user_type', userRole);  
    localStorage.setItem('user_id', userId);  

    supplierForm.value = {
      name: '',
      email: '',
      phone: '',
      password: '',
      state_id: '',
      city_id: '',
      category_id: '',
      company_email:'',
      company_landline_phone:'',
      factory_phone:'',
      sales_phone:'',
      website_url:'',
      branch_name:''
    }
    supplierErrors.value = {}
    if (userRole === 'Service Provider') {
      router.push(`/dashboard/${userId}`);
    } else {
      router.push(`/user_dashboard/${userId}`);
    }
  } catch (error) {
    if (error.response && error.response.status === 422) {
      supplierErrors.value = error.response.data || {}
      const msg = Object.values(supplierErrors.value).flat().join('\n')
      toast.error(msg)
    } else {
      toast.error(t('An unexpected error occurred. Please try again.'))
      console.error('Registration error:', error)
    }
  } finally {
    isSubmitting.value = false
  }
}

onMounted(() => {
  const options = {
    loadUtils: () => import('intl-tel-input/utils'),
  }

  phoneIti.value = intlTelInput(phoneInput.value, options)

  factoryPhoneIti.value = intlTelInput(factoryPhoneInput.value, options)

  salesPhoneIti.value = intlTelInput(salesPhoneInput.value, options)
})

onBeforeUnmount(() => {
  phoneIti.value?.destroy()
  factoryPhoneIti.value?.destroy()
  salesPhoneIti.value?.destroy()
})
</script>
<style>
.iti {
  --iti-path-flags-1x: url('../../node_modules/intl-tel-input/build/img/flags.webp');
  --iti-path-flags-2x: url('../../node_modules/intl-tel-input/build/img/flags@2x.webp');
  --iti-path-globe-1x: url('../../node_modules/intl-tel-input/build/img/globe.webp');
  --iti-path-globe-2x: url('../../node_modules/intl-tel-input/build/img/globe@2x.webp');
}
.iti input.iti__tel-input, .iti input.iti__tel-input[type=text], .iti input.iti__tel-input[type=tel]
{
  position: relative;
  z-index: 0;
  margin: 0 !important;
  width: 337px;
}
[dir="ltr"] .iti input.iti__tel-input {
text-align: left;
}

[dir="rtl"] .iti input.iti__tel-input {
  text-align: right;
}
</style>

